// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__bnc5F","menu":"MainLayout_menu__3hSgm","menuitem":"MainLayout_menuitem__3twGI","content":"MainLayout_content__2OhFP"};